// extracted by mini-css-extract-plugin
export default {"menu":"addButton_menu__FhoCp","optionButton":"addButton_optionButton__udwNt"};